import { removePhoneNumCountryCode } from '@unified-checkout/design-system';
import { getCountryFromDomain } from './getCountryFromDomain';

export const phoneWithoutCountryCode = (phone: string, country?: string) => {
  const countryFromDomain = getCountryFromDomain();

  const COUNTRY = country || countryFromDomain;

  return removePhoneNumCountryCode(phone, COUNTRY);
};
